import { useCallback } from "react";

const useCliManagement = (cli, setCli) => {
  const handleChangeLineValue = useCallback(
    (index, value) => {
      let tempArray = [...cli];
      let linesArray = [];
      for (let i = 0; i < value; i++) {
        linesArray.push({
          legacy: null,
          legacyService1: null,
          legacyService2: null,
          legacyService3: null,
          legacyService4: null,
          ngnValue: null,
          ngnService1: null,
          ngnService2: null,
          ngnService3: null,
          ngnService4: null,
        });
      }
      tempArray[index].line = value;
      tempArray[index].lineValues = linesArray;
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleDisableLine = useCallback(
    (mainIndex) => {
      let tempArray = [...cli];
      if (tempArray[mainIndex].legacyTariff.isSelected === false) {
        tempArray[mainIndex].cliNumber = !tempArray[mainIndex].cliNumber;
      }

      // When legacy is not selected than this block runss
      if (tempArray[mainIndex].legacyTariff.isSelected === false) {
        tempArray[mainIndex].upgradeCharge.isSelected =
          !tempArray[mainIndex].cliNumber;
        tempArray[mainIndex].migration.isSelected = false;
        tempArray[mainIndex].transfer.isSelected = false;
      }

      let newArr = tempArray.map((val, ind) => {
        if (mainIndex === ind) {
          return {
            ...val,
            mobileNo: val.cliNumber ? "" : "00000000",
          };
        } else {
          return val;
        }
      });
      setCli(newArr);
    },
    [cli, setCli]
  );

  // Add today
  const handleUpdateNumber = useCallback(
    (mainIndex) => {
      let tempArray = [...cli];
      tempArray[mainIndex].upgradeCharge.isSelected = true;
      tempArray[mainIndex].migration.isSelected = false;
      tempArray[mainIndex].transfer.isSelected = false;

      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleChangeCliNumber = useCallback(
    (mainIndex, value) => {
      let tempArray = [...cli];
      tempArray[mainIndex].mobileNo = value;
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleChangeAddress = useCallback(
    (ind, value) => {
      let tempArray = [...cli];
      tempArray[ind].differentAddress.value = value;
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleChangeUpgradeCharge = useCallback(
    (ind, value, type) => {
      if (type === "upgradeCharge" && value < 55) {
        return;
      }

      if (type === "migration" && value < 0) {
        return;
      }

      let tempArray = [...cli];
      tempArray[ind][type].salePrice = parseFloat(value);
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleSelectUpgradeAttachedValue = useCallback(
    (ind, value, type) => {
      let tempArray = [...cli];
      tempArray[ind][type].attachedValue = value;
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handleSelectTimePeriod = useCallback(
    (ind, value, type, key) => {
      let tempArray = [...cli];
      tempArray[ind][type][key] = value;
      setCli(tempArray);
    },
    [cli, setCli]
  );
  const handleUpdateSaleType = useCallback(
    (ind, value, saleType, key) => {
      let tempArray = [...cli];
      tempArray[ind][saleType][key] = value;

      // Condition No :01 If Key is isImmediate and value is true live date is set to null
      if (key === "isImmediate" && value === false) {
        tempArray[ind][saleType].liveDate = null;
      }

      setCli(tempArray);

    },
    [cli, setCli]
  );

  const handleSelectPaymentWauy = useCallback(
    (ind, type, value) => {
      let tempArray = [...cli];

      if (type === "upgradeCharge") {
        tempArray[ind][type].upPayment = !tempArray[ind][type].upPayment;
        tempArray[ind][type].isCollected = "";
      }

      if (type === "migration" && value === "up") {
        tempArray[ind][type].upPayment = true;
        tempArray[ind][type].firstMonth = false;
      }

      if (type === "migration" && value === "first") {
        tempArray[ind][type].firstMonth = true;
        tempArray[ind][type].upPayment = false;
        tempArray[ind][type].isCollected = "";
      }

      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handeDeleteCliBox = useCallback(
    (ind) => {
      let tempArray = [...cli];
      tempArray.splice(ind, 1);
      setCli(tempArray);
    },
    [cli, setCli]
  );

  const handlAddCliBox = useCallback(() => {
    let obj = {
      mobileNo: "",
      cliNumber: true,
      line: 1,
      legacyTariff: {
        title: "Legacy",
        isSelected: false,
        type: "legacyTariff",
      },
      digitalTariff: {
        title: "Digital/NGN",
        isSelected: true,
        type: "digitalTariff",
      },
      additionalService: {
        title: "Additional services",
        isSelected: false,
        type: "additionalService",
      },
      differentAddress: {
        title: "Different Address",
        isSelected: true,
        type: "differentAddress",
        value: "",
      },
      upgradeCharge: {
        title: "Install",
        isSelected: false,
        type: "upgradeCharge",
        salePrice: 60,
        buyPrice: 60,
        attachedValue: "",
        timePeriod: "",
        upPayment: true,
        isCollected: "",
        liveDate: null,
        isImmediate: true,
      },
      migration: {
        title: "Migration",
        isSelected: false,
        type: "migration",
        salePrice: 60,
        buyPrice: 60,
        attachedValue: "",
        timePeriod: "",
        upPayment: false,
        firstMonth: false,
        isCollected: "",
        liveDate: null,
        isImmediate: true,
      },
      transfer: {
        title: "Transfer",
        isSelected: false,
        type: "transfer",
        attachedValue: "",
        liveDate: null,
        isImmediate: true,
      },
      lineValues: [
        {
          legacy: null,
          legacyService1: null,
          legacyService2: null,
          legacyService3: null,
          legacyService4: null,
          ngnValue: null,
          ngnService1: null,
          ngnService2: null,
          ngnService3: null,
          ngnService4: null,
        },
      ],
    };
    let tempArray = [...cli];
    tempArray.push(obj);
    setCli(tempArray);
  }, [cli, setCli]);

  const handleCheckedOptions = useCallback(
    (index, type) => {
      let tempArray = [...cli];
      if (type === "legacyTariff") {
        tempArray[index].legacyTariff.isSelected = true;
        tempArray[index].digitalTariff.isSelected = false;
        tempArray[index].cliNumber = true;
        tempArray[index].mobileNo = "";

        // when legacy set to false by default transfer is selected
        // and false the other no matter nill is selected or not

        // Install change reffer as upgrade charge
        if (tempArray[index].upgradeCharge)
          tempArray[index].upgradeCharge.isSelected = false;

        // Migration
        if (tempArray[index].migration)
          tempArray[index].migration.isSelected = false;

        // Transfer which set to true
        if (tempArray[index].transfer)
          tempArray[index].transfer.isSelected = true;
      }

      if (type === "digitalTariff") {
        tempArray[index].digitalTariff.isSelected = true;
        tempArray[index].legacyTariff.isSelected = false;

        // When digital tarrif set to true all charged become false
        // but if cli Number is false its select by default to install

        if (tempArray[index].cliNumber === false) {
          // Install change reffer as upgrade charge
          if (tempArray[index].upgradeCharge)
            tempArray[index].upgradeCharge.isSelected = true;

          // Migration
          if (tempArray[index].migration)
            tempArray[index].migration.isSelected = false;

          // Transfer which set to true
          if (tempArray[index].transfer)
            tempArray[index].transfer.isSelected = false;
        } else {
          // Install change reffer as upgrade charge
          if (tempArray[index].upgradeCharge)
            tempArray[index].upgradeCharge.isSelected = false;

          // Migration
          if (tempArray[index].migration)
            tempArray[index].migration.isSelected = false;

          // Transfer which set to true
          if (tempArray[index].transfer)
            tempArray[index].transfer.isSelected = false;
        }
      }

      if (type === "additionalService") {
        tempArray[index].additionalService.isSelected =
          !tempArray[index].additionalService.isSelected;
      }

      if (type === "differentAddress") {
        tempArray[index].differentAddress.isSelected =
          !tempArray[index].differentAddress.isSelected;
      }

      if (type === "upgradeCharge") {
        if (tempArray[index]) {
          tempArray[index].upgradeCharge.isSelected =
            !tempArray[index].upgradeCharge.isSelected;
          if (tempArray[index].migration)
            tempArray[index].migration.isSelected = false;
          if (tempArray[index].transfer)
            tempArray[index].transfer.isSelected = false;
        }
      }

      if (type === "migration") {
        if (tempArray[index]) {
          tempArray[index].migration.isSelected =
            !tempArray[index].migration.isSelected;
          if (tempArray[index].upgradeCharge)
            tempArray[index].upgradeCharge.isSelected = false;
          if (tempArray[index].transfer)
            tempArray[index].transfer.isSelected = false;
        }
      }

      if (type === "transfer") {
        if (tempArray[index]) {
          tempArray[index].transfer.isSelected =
            !tempArray[index].transfer.isSelected;
          if (tempArray[index].upgradeCharge)
            tempArray[index].upgradeCharge.isSelected = false;
          if (tempArray[index].migration)
            tempArray[index].migration.isSelected = false;
        }
      }

      setCli(tempArray);
    },
    [cli, setCli]
  );

  return {
    handleChangeLineValue,
    handleDisableLine,
    handleChangeCliNumber,
    handleChangeAddress,
    handeDeleteCliBox,
    handlAddCliBox,
    handleCheckedOptions,
    handleChangeUpgradeCharge,
    handleSelectUpgradeAttachedValue,
    handleUpdateNumber,
    handleSelectTimePeriod,
    handleSelectPaymentWauy,
    handleUpdateSaleType,
  };
};

export default useCliManagement;
